import "./home.styles.scss";
import { Hero } from "./components/Hero/Hero";
import { Skills } from "./components/Skills/Skills";
import { FeaturedWork } from "./components/FeaturedWork/FeaturedWork";

export const Home = () => {
  return (
    <main className="home">
      <Hero />
      <Skills />
      <FeaturedWork />
    </main>
  );
};
